module.exports = __webpack_public_path__ + "media/images/work-on-tickets-ac49f6540550e216eaf68a4a3675df58.svg";